<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [isShowModal]="false"
  (valueChange)="changed($event)"
  [model]="model"
  [columns]="columns"
  (cancelChange)="cancel()"
  secondClass="main-page">
  <ng-container class="fctContent">
    <ssg-button
      (click)="createReport()"
      class="login-btn"
      [label]="'ClientApp.FrontOffice.SaleReportDesigner.ReportDesign' | translate"
      buttontype="button"
      size="large"
      appearance="flat">
    </ssg-button>
    <ssg-button
      (click)="printReport()"
      class="login-btn"
      [label]="'ClientApp.FrontOffice.SaleReportDesigner.Print' | translate"
      buttontype="button"
      size="medium"
      appearance="flat">
    </ssg-button>
    <ssg-button
      (click)="previewReport()"
      class="login-btn"
      [label]="'ClientApp.FrontOffice.SaleReportDesigner.Preview' | translate"
      buttontype="button"
      size="medium"
      appearance="flat">
    </ssg-button>
  </ng-container>
</dynamic-form>
